import { Component } from '@angular/core';
import packageInfo from '../../package.json';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false
})
export class AppComponent {
  constructor() {
    console.log(
      `%c VERSION: ${packageInfo.version}`,
      'color: white; font-size: 14px;background-color:#356dcc'
    );
  }
}
